import Translations from '@helpers/translations'
import { ProductWithVariants } from 'types/product'
import { sizeChartUrl } from '@helpers/sizeChart'
import Link from '@components/ui/Link/index'
import styles from './styles.module.scss'
import { fitInstructions } from '@helpers/products/fitInstructions'

type Props = {
  product: ProductWithVariants
}

function SizeAndFitInstructions({ product }: Props) {
  const {
    options: productOptions,
    product_type: productType,
    product_feed: productFeed
  } = product

  return (
    <ul>
      {fitInstructions[productType].split('|').map(line => (
        <li>{line}</li>
      ))}
      <li className={styles.links}>
        Fine-tuning? See the &nbsp;
        <Link
          text={Translations.localise('product.filters.size-chart')}
          classes="link--block"
          href={sizeChartUrl(
            productOptions,
            productType,
            productFeed?.product_category
          )}
        />
      </li>
    </ul>
  )
}

export default SizeAndFitInstructions
